import {  Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Distributor } from '../../../models/Distributor';
import { FilterObject } from '../../../models/FilterObject';
import { Item } from '../../../models/Item';
import { User } from '../../../models/User';
import { GlobalService } from '../../../services/global';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-item-search',
  templateUrl: './item-search.component.html',
  styleUrls: ['./item-search.component.css']
})
export class ItemSearchComponent implements OnInit {
  @Output() CloseEventEmitter: EventEmitter<any> = new EventEmitter();
  @Output() ItemSelectEmitter: EventEmitter<Item> = new EventEmitter();
  @ViewChild(MatPaginator) itemSearchPaginator: MatPaginator;
  PageSize: number;
  PageIndex: number;
  ItemList: Item[];
  ItemCount: number;
  FilterList: FilterObject[];
  ItemNumberSearch: FilterObject;
  DescSearch: FilterObject;
  JobNumberSearch: FilterObject;
  SerialNumberSearch: FilterObject;
  CustomerSearch: FilterObject;
  EnteredItemNumber: string;
  AdvancedSearch: boolean;
  CurrentDist: Distributor;
  UseGivenDistributor: boolean;
  hideLoadingModal: boolean;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];


  constructor(private http: HttpService, private global: GlobalService) {
    this.UseGivenDistributor = false;
  }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    
    this.AdvancedSearch = false;
    this.PageSize = 10;
    this.PageIndex = 0;
    this.FilterList = [];
    this.ItemNumberSearch = new FilterObject();
    this.ItemNumberSearch.Key = "item";
    if (this.EnteredItemNumber) {
      this.ItemNumberSearch.Value = this.EnteredItemNumber;
    }
    else {
      this.ItemNumberSearch.Value = "";
    }

    this.CustomerSearch = new FilterObject();
    this.CustomerSearch.Key = "customer";
    this.CustomerSearch.Value = "";
    this.DescSearch = new FilterObject();
    this.JobNumberSearch = new FilterObject();
    this.SerialNumberSearch = new FilterObject();
    this.global.getCurrentDist().then(dist => {
      if (!this.UseGivenDistributor) {
        this.CurrentDist = dist;
        if (this.CurrentDist && this.CurrentDist.Permissions && this.CurrentDist.Permissions.length > 0 && this.CurrentDist.Permissions.some(x => x.Page.toLowerCase() == "pricing" && x.Action.toLowerCase() == "contract")) {
          this.CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
          this.FilterList.push(this.CustomerSearch);
        }
        else if (this.CurrentDist) {
          if (this.CurrentDist) {
            this.CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
            this.FilterList.push(this.CustomerSearch);
          }
        }
      } else {
        this.CustomerSearch.Value = this.CurrentDist.CstaccountNumber;
        this.FilterList.push(this.CustomerSearch);
      }
      
      this.DescSearch.Key = "description";
      this.DescSearch.Value = "";

      
      this.JobNumberSearch.Key = "job";
      this.JobNumberSearch.Value = "";

      
      this.SerialNumberSearch.Key = "serial";
      this.SerialNumberSearch.Value = "";


      this.FilterList.push(this.ItemNumberSearch);
      this.FilterList.push(this.DescSearch);
      this.FilterList.push(this.JobNumberSearch);
      this.FilterList.push(this.SerialNumberSearch);


      this.LoadItems();
    });
    
  }

  LoadItems() {
    this.hideLoadingModal = false;
    if (this.SerialNumberSearch.Value.length > 0 || this.JobNumberSearch.Value.length > 0 || this.CustomerSearch.Value.length > 0) {
      this.http.AdvancedItemSearch(this.FilterList, this.PageIndex, this.PageSize).then(x => {
        this.ItemList = x.Items;
        this.ItemCount = x.ItemCount;
        this.hideLoadingModal = true;
      });
    }
    else {
      this.http.ItemSearch(this.FilterList, this.PageIndex, this.PageSize).then(x => {
        this.ItemList = x.Items;
        this.ItemCount = x.ItemCount;
        this.hideLoadingModal = true;
      });
    }
    
  }

  AdvancedSearch_Click() {
    this.PageIndex = 0;
    this.LoadItems();
  }
  PageEvent(event: any) {
    this.PageSize = event.pageSize;
    this.PageIndex = event.pageIndex;
    this.LoadItems();
  }

  SelectItem(item: Item) {
    this.ItemSelectEmitter.emit(item);
  }

  CloseSearch() {
    this.CloseEventEmitter.emit("");
  }

}
